export default {
	data() {
		return {
			detailsOpened: false
		};
	}
};
